import { cx } from 'lib/cx'
import React from 'react'

export type ParagraphProps = {
  className?: string
  children: React.ReactNode
}

export function Paragraph(props: ParagraphProps) {
  return (
    <p className={cx('whitespace-pre-wrap', props.className)}>
      {props.children}
    </p>
  )
}
